import React from "react";
import "./Section2.css";
import CardImage1 from "../../../../../assets/images/advancetaxsr-sec2card1.png";
import CardImage2 from "../../../../../assets/images/advancetaxsr-sec2card2.png";
import CardImage3 from "../../../../../assets/images/advancetaxsr-sec2card3.png";
import Card1 from "../../../../../Components/Cards/Card1";
const Section2 = () => {
  return (
    <div className="taxplanning__service_section2">
      <div className="taxplanning__service_sec2card">
        <Card1
          containerStyle={{ minHeight: "380px" }}
          image={CardImage1}
          dotColor="transparent"
          backgroundColor="rgba(0, 142, 255, 0.15)"
          description="Our staff will show you how to adjust your payroll withholding to get more money back each week. Why give the IRS an interest free loan for up to 16 months."
        />
      </div>
      <div className="taxplanning__service_sec2card">
        <Card1
          containerStyle={{ minHeight: "380px" }}
          image={CardImage2}
          dotColor="transparent"
          backgroundColor="rgba(0, 142, 255, 0.15)"
          description="Our staff will show you how to adjust your payroll withholding to get more money back each week. Why give the IRS an interest free loan for up to 16 months."
        />
      </div>
      <div className="taxplanning__service_sec2card">
        <Card1
          containerStyle={{ minHeight: "380px" }}
          image={CardImage3}
          dotColor="transparent"
          backgroundColor="rgba(0, 142, 255, 0.15)"
          description="Our staff will show you how to adjust your payroll withholding to get more money back each week. Why give the IRS an interest free loan for up to 16 months."
        />
      </div>
    </div>
  );
};

export default Section2;
